import styled from 'styled-components';

import { MpText } from 'shared/ui/MpText';

export const UserApplicationContainerStyled = styled.section`
	min-height: 40vh;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
`;

export const MyApplicationsHeaderStyled = styled.h3`
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 24px;
`;

export const MyApplicationsListStyled = styled.div`
	grid-template-columns: 1fr 1fr;
	gap: 24px;
	display: grid;
	flex-wrap: wrap;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		gap: 16px;
		display: flex;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 24px;
		display: grid;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		gap: 12px;
	}
`;

export const MyApplicationsLoadingContainerStyled = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
	padding: 40px 0;
	min-height: 40vh;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
`;

export const CenteredContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 150px;
	width: 100%;
`;

export const HeadingStyled = styled.h2`
	margin-bottom: 16px;
	font-weight: 600;
	font-size: 20px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 30px;
		margin-bottom: 24px;
	}
`;

export const MyAppsHeaderStyled = styled.h3`
	margin-bottom: 24px;
	font-weight: 600;
	font-size: 24px;
`;

export const TextStyled = styled(MpText)`
	margin-bottom: 24px;

	text-align: center;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 585px;
		margin-bottom: 36px;
	}
`;
